import "./InnoleafJourneys.module.css";
import Header from "@/reusable_sections/Header";
import Departure from "./sections/Departure";
import TrustedByTravellers from "./sections/TrustedByTravellers";
import Journeys from "./sections/Journeys";
import Expeditions from "./sections/Expeditions";
import Footprint from "./sections/Footprint";
import Chronicles from "./sections/Chronicles";
import InnoleafFooter from "@/reusable_sections/Footer";
import IntroStatement from "./sections/IntroStatement";
export default function InnoleafJourneysPage() {
  return <div>
      <Header />
      <IntroStatement />
      <Departure />
      <TrustedByTravellers />
      <Journeys />
      <Expeditions />
      <Footprint />
      <Chronicles />
      <InnoleafFooter />
    </div>;
}